import { CdnImg } from '@webplatform/cdn-image';


export default {
  __name: 'CatalogProductCard',
  props: {
  image: {
    type: Object,
    default: () => {},
  },
  name: {
    type: String,
    default: 'Prime Series (UHD) 65”',
  },
  description: {
    type: String,
    default: '',
  },
  isNew: {
    type: Boolean,
    default: false,
  },
  link: {
    type: String,
    default: null,
  },
},
  setup(__props) {



return { __sfc: true,CdnImg }
}

}